import React, { FunctionComponent } from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';

import { DimensionSettings } from '@paragon/contract-library';

import { DimensionLabelTypeSelect } from '../controls/DimensionLabelTypeSelect';
import { DimensionVisibilitySelect } from '../controls/DimensionVisibilitySelect';
import { SettingsDialogColumn } from '../SettingsDialogContainer';
import { SettingsControlProps } from '../types';

type Props = SettingsControlProps<DimensionSettings>;

export const DimensionSettingsColumn: FunctionComponent<Props> = ({ value, onChange }) => (
  <SettingsDialogColumn title="Dimensions">
    <FormControlLabel
      control={
        <Checkbox
          color="default"
          checked={value.showGrid}
          onChange={(event) => onChange({ showGrid: event.target.checked })}
        />
      }
      label="Show Grid"
    />

    <FormControlLabel
      control={
        <Checkbox
          color="default"
          checked={value.showStandardDimensions}
          onChange={(event) => onChange({ showStandardDimensions: event.target.checked })}
        />
      }
      label="Show Standard Dimensions"
    />

    <DimensionVisibilitySelect
      value={value.visibleDimensionCategory}
      onChange={(visibleDimensionCategory) => onChange({ visibleDimensionCategory })}
    />

    <DimensionLabelTypeSelect
      value={value.dimensionLabelType}
      onChange={(dimensionLabelType) => onChange({ dimensionLabelType })}
    />

    <FormControlLabel
      control={
        <Checkbox
          color="default"
          checked={value.showPitch}
          onChange={(event) => onChange({ showPitch: event.target.checked })}
        />
      }
      label="Show Pitch"
    />

    <FormControlLabel
      control={
        <Checkbox
          color="default"
          checked={value.showSelectedMemberCutAngles}
          onChange={(event) => onChange({ showSelectedMemberCutAngles: event.target.checked })}
        />
      }
      label="Show selected member's cut angles"
    />

    <FormControlLabel
      control={
        <Checkbox
          color="default"
          checked={value.showSelectedMemberLengthDimensions}
          onChange={(event) => onChange({ showSelectedMemberLengthDimensions: event.target.checked })}
        />
      }
      label="Show selected member's length"
    />
  </SettingsDialogColumn>
);
